import { render, staticRenderFns } from "./PaymentRequisites.vue?vue&type=template&id=9f8891c6&lang=pug"
import script from "./PaymentRequisites.vue?vue&type=script&lang=js"
export * from "./PaymentRequisites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports